import StarterKit from "./StarterKit";

import ImagesLoaded from './events/ImagesLoaded';

import HeaderFull from "./components/HeaderFull";
import HeaderBurger from "./components/HeaderBurger";
import RangesMenu from './components/RangesMenu';
import HashScroll from './components/HashScroll';

// import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
import BlockScrollingText from "./blocks/BlockScrollingText";
import BlockKeyNumbers from './blocks/BlockKeyNumbers';
import LocalisationMarker from './components/LocalisationMarker';
import BlockTimeline from './blocks/BlockTimeline';
import BlockGeographicLocationMap from './blocks/BlockGeographicLocationMap';


document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	HeaderFull.init();
	HeaderBurger.init();
	RangesMenu.init();
	HashScroll.init();

	// Blocks
	// BlockBanner.init();
	BlockCollapse.init();
	BlockGallerySlider.init();
	BlockMap.init();
	BlockMovie.init();
	BlockQuotes.init();
	BlockSlider.init();
	BlockScrollingText.init();
	BlockKeyNumbers.init();
	LocalisationMarker.init();
	BlockTimeline.init();
	BlockGeographicLocationMap.init();
});

// Needs to run BEFORE DOM content loaded event, as natively lazy loaded
// images in viewport are ready before the event is triggered.
ImagesLoaded.init();
